import api from 'api/api'
import { format } from 'date-fns'
import { toast } from 'react-toastify'
import { downloadBlob } from 'utils/download-blob'

export const SEARCH_PRODUCTS = "[PRODUCTS] SEARCH PRODUCTS"
export const GET_PRODUCTS_BY_SUPPLIER_ID = "[PRODUCTS] GET PRODUCTS BY SUPPLIER ID"
export const DOWNLOADING_PRODUCT_PRICES_LIST_EXCEL = "[PRODUCTS] DOWNLOADING PRODUCT PRICES LIST EXCEL"

export function searchProductsAction(params = { query: '', productType: null, storeId: null, limit: 50 }) {
  if (!params.query?.trim()) {
    return (dispatch) => dispatch({ type: SEARCH_PRODUCTS, payload: { loading: false, data: [] } })
  }
  const request = api.get('/products/search', { params })
  return (dispatch) => {
    dispatch({ type: SEARCH_PRODUCTS, payload: { loading: true } })
    request.then(response => {
      dispatch({ type: SEARCH_PRODUCTS, payload: { data: response.data.data } })
    }).catch(error => {
      dispatch({ type: SEARCH_PRODUCTS, payload: { data: [] } })
      console.log(SEARCH_PRODUCTS, error)
    }).finally(() => {
      dispatch({ type: SEARCH_PRODUCTS, payload: { loading: false } })
    })
  }
}

export function getProductsBySupplierIdAction(supplierId) {
  const request = api.get(`/products/by-supplier/${supplierId}`)
  return (dispatch) => {
    dispatch({ type: GET_PRODUCTS_BY_SUPPLIER_ID, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_PRODUCTS_BY_SUPPLIER_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: GET_PRODUCTS_BY_SUPPLIER_ID, payload: { data: [] } })
      console.log(GET_PRODUCTS_BY_SUPPLIER_ID, error)
    }).finally(() => {
      dispatch({ type: GET_PRODUCTS_BY_SUPPLIER_ID, payload: { loading: false } })
    })
  }
}

export function downloadProductPricesListExcelAction(priceType = 'precioventa') {
  const request = api.get(`/products/prices-list-excel/${priceType}`, { responseType: 'blob' })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_PRODUCT_PRICES_LIST_EXCEL, payload: true })
    request.then((response) => {
      const fileName = `LISTA DE PRECIOS - ${format(new Date(), 'dd.MM.yyyy')}.xlsx`
      downloadBlob(response.data, fileName)
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'No se pudo descargar la lista de precios')
      console.log(DOWNLOADING_PRODUCT_PRICES_LIST_EXCEL, error)
    }).finally(() => {
      dispatch({ type: DOWNLOADING_PRODUCT_PRICES_LIST_EXCEL, payload: false })
    })
  }
}